var map = {
	"./activity.svg": "pCGP",
	"./all-of-your-work.png": "h0x2",
	"./calendars.svg": "WmjY",
	"./catch-up-feed.mp4": "gNyX",
	"./feed.svg": "zuFt",
	"./filter.svg": "DuDt",
	"./project-dashboard.mp4": "QTxW",
	"./projects.svg": "hWnr",
	"./single-sign-on.svg": "70se",
	"./team.svg": "hd/+",
	"./teams-of-all-sizes.png": "6Gvd",
	"./timelines.svg": "sF+l",
	"./view.svg": "H6tL"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xnx4";